/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";
import { AuthProvider } from "context/authContext";
import ErrorBoundaryWithAuth from "components/ErrorBoundary";

const container = document.getElementById("app");

// The new app lives under /v2 and is loaded on demand; every other path renders the classic app unchanged.
const isNewApp = /^\/v2(\/|$)/.test(window.location.pathname);

if (isNewApp) {
  import("v2").then(({ default: mount }) => mount(container));
} else {
  renderClassic();
}

function renderClassic() {
  const root = createRoot(container);
  root.render(
    <AuthProvider>
      <BrowserRouter>
        <MaterialUIControllerProvider>
          <ErrorBoundaryWithAuth>
            <App />
          </ErrorBoundaryWithAuth>
        </MaterialUIControllerProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}
